module.exports = __webpack_public_path__ + "dl.8a53c2be.svg";